import { MessageCircle } from "lucide-react";

export default function WhatsAppFloat() {
  const phone = "9412222077";
  const msg = encodeURIComponent(
    "Hi Horizn Ad Media, I'd like to plan an OOH campaign."
  );
  return (
    <a
      data-testid="whatsapp-float"
      href={`https://wa.me/${phone}?text=${msg}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-40 group"
      aria-label="Chat on WhatsApp"
    >
      <span className="absolute inset-0 rounded-full bg-green-500/40 blur-xl group-hover:bg-green-500/60 transition-colors" />
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-green-500 text-white shadow-lg shadow-green-500/30 hover:scale-110 transition-transform">
        <MessageCircle className="h-6 w-6" />
      </span>
    </a>
  );
}
